import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=1dc4b27b"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=1dc4b27b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports